/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type UserFragment = {
  __typename: "User"
  id: string
  name?: string | null
  email: string
  createdAt: string
  updatedAt: string
}

export type TeamMemberFragment = {
  __typename: "TeamMember"
  id: string
  role: string
  invitedAt?: string | null
  invitationAcceptedAt?: string | null
  invitationAccepted: boolean
  createdAt: string
  updatedAt: string
  user?: {
    __typename: "User"
    id: string
    name?: string | null
    email: string
    createdAt: string
    updatedAt: string
  } | null
}

export const UserFragmentDoc = gql`
  fragment User on User {
    id
    name
    email
    createdAt
    updatedAt
  }
`
export const TeamMemberFragmentDoc = gql`
  fragment TeamMember on TeamMember {
    id
    role
    invitedAt
    invitationAcceptedAt
    invitationAccepted
    createdAt
    updatedAt
    user @type(name: "User") {
      ...User
    }
  }
  ${UserFragmentDoc}
`
